import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import { FileProviderItemViewState } from 'owa-filepicker';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    AttachmentFileList,
    createAttachmentItemFileFromDataProviderItem,
    createCloudFileFromDataProviderItem,
    createLocalComputerFiles,
    createMailItemFiles,
} from 'owa-attachment-file-types';

export function onCloudFilesSelected(
    createAttachmentHandler: CreateAttachmentHandler,
    fileProviderItems: FileProviderItemViewState[],
    shouldShare: boolean
): void {
    const providerType =
        fileProviderItems.length > 0 ? fileProviderItems[0].model.ProviderType : null;

    let attachmentFileList: AttachmentFileList | null = null;
    if (providerType && providerType === AttachmentDataProviderType.MailMessage) {
        const subjectList = [];
        const idList = [];
        fileProviderItems.forEach(item => {
            subjectList.push(item.model.Subject);
            idList.push(item.model.Id);
        });

        attachmentFileList = createMailItemFiles(subjectList, idList);
    } else {
        attachmentFileList = fileProviderItems.map(viewState =>
            createCloudFileFromDataProviderItem(viewState.model)
        );
    }

    onFilesChange(
        createAttachmentHandler,
        attachmentFileList,
        shouldShare,
        false /* isInline */,
        providerType
    );
}

export function onLocalFilesSelected(
    createAttachmentHandler: CreateAttachmentHandler,
    files: File[],
    isInline: boolean,
    shouldShare: boolean
): void {
    const localComputerFiles = createLocalComputerFiles(files);
    onFilesChange(createAttachmentHandler, localComputerFiles, shouldShare, isInline);
}

export function onRecentAttachmentFilesSelected(
    createAttachmentHandler: CreateAttachmentHandler,
    fileProviderItems: FileProviderItemViewState[]
): void {
    const providerType =
        fileProviderItems.length > 0 ? fileProviderItems[0].model.ProviderType : null;

    const cloudyItems: FileProviderItemViewState[] = fileProviderItems.filter(
        item => item.location !== null
    );
    const classicItems: FileProviderItemViewState[] = fileProviderItems.filter(
        item => item.location === null
    );

    if (cloudyItems.length > 0) {
        onFilesChange(
            createAttachmentHandler,
            cloudyItems.map(viewState => createCloudFileFromDataProviderItem(viewState.model)),
            true /*shouldShare*/,
            false /* isInline */,
            providerType
        );
    }

    if (classicItems.length > 0) {
        onFilesChange(
            createAttachmentHandler,
            classicItems.map(viewState =>
                createAttachmentItemFileFromDataProviderItem(viewState.model)
            ),
            false /*shouldShare*/,
            false /* isInline */,
            providerType
        );
    }
}

function onFilesChange(
    createAttachmentsHandler: CreateAttachmentHandler,
    files: AttachmentFileList,
    shouldShare: boolean = false,
    isInline: boolean = false,
    dataProviderType: AttachmentDataProviderType = null
) {
    createAttachmentsHandler({
        files: files,
        shouldShare: shouldShare,
        isInline: isInline,
        dataProviderType: dataProviderType,
    });
}
